export default __webpack_public_path__ + "static/media/users.7a39aacc.svg";